var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLesotho(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_595)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.9999C0 23.1163 0.713047 26.0662 1.98453 28.6955L20 29.5652L38.0155 28.6956C39.2869 26.0662 40 23.1163 40 19.9999C40 16.8835 39.2869 13.9337 38.0155 11.3043L20 10.4347L1.98453 11.3042C0.713047 13.9337 0 16.8835 0 19.9999H0Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 40C27.9292 40 34.7806 35.3855 38.0156 28.6956H1.98462C5.21962 35.3855 12.0709 40 20.0001 40Z",
    fill: "#6DA544"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.0001 -0.00012207C12.0709 -0.00012207 5.21962 4.61433 1.98462 11.3043H38.0155C34.7806 4.61433 27.9292 -0.00012207 20.0001 -0.00012207V-0.00012207Z",
    fill: "#0052B4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.3044 19.565V14.7825H18.6958V19.565L15.545 22.7159C16.4613 24.2159 18.1137 25.2172 20.0001 25.2172C21.8865 25.2172 23.5389 24.2159 24.4553 22.7159L21.3044 19.565Z",
    fill: "black"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_595"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLesotho);
export default __webpack_public_path__ + "static/media/lesotho.78c12a0c25e9dc5d41f6c197aef15c63.svg";
export { ForwardRef as ReactComponent };